var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.858 28.2C28.8646 28.2 34.5441 22.5585 34.5441 15.6C34.5441 8.64145 28.8636 3 21.858 3C14.8524 3 9.17188 8.64145 9.17188 15.6C9.17188 22.5585 14.8518 28.2 21.858 28.2Z",
    fill: "url(#paint0_linear_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.858 28.2C28.8646 28.2 34.5441 22.5585 34.5441 15.6C34.5441 8.64145 28.8636 3 21.858 3C14.8524 3 9.17188 8.64145 9.17188 15.6C9.17188 22.5585 14.8518 28.2 21.858 28.2Z",
    fill: "url(#paint1_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.858 28.2C28.8646 28.2 34.5441 22.5585 34.5441 15.6C34.5441 8.64145 28.8636 3 21.858 3C14.8524 3 9.17188 8.64145 9.17188 15.6C9.17188 22.5585 14.8518 28.2 21.858 28.2Z",
    fill: "url(#paint2_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.858 28.2C28.8646 28.2 34.5441 22.5585 34.5441 15.6C34.5441 8.64145 28.8636 3 21.858 3C14.8524 3 9.17188 8.64145 9.17188 15.6C9.17188 22.5585 14.8518 28.2 21.858 28.2Z",
    fill: "url(#paint3_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4283 36.6C39.2669 36.6 44 31.8993 44 26.1C44 20.3007 39.2669 15.6 33.4283 15.6C27.5901 15.6 22.8569 20.3007 22.8569 26.1C22.8569 31.8993 27.5901 36.6 33.4283 36.6Z",
    fill: "url(#paint4_linear_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4283 36.6C39.2669 36.6 44 31.8993 44 26.1C44 20.3007 39.2669 15.6 33.4283 15.6C27.5901 15.6 22.8569 20.3007 22.8569 26.1C22.8569 31.8993 27.5901 36.6 33.4283 36.6Z",
    fill: "url(#paint5_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4283 36.6C39.2669 36.6 44 31.8993 44 26.1C44 20.3007 39.2669 15.6 33.4283 15.6C27.5901 15.6 22.8569 20.3007 22.8569 26.1C22.8569 31.8993 27.5901 36.6 33.4283 36.6Z",
    fill: "url(#paint6_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4428 45C28.4055 45 32.4285 41.0041 32.4285 36.075C32.4285 31.1459 28.4055 27.15 23.4428 27.15C18.48 27.15 14.457 31.1459 14.457 36.075C14.457 41.0041 18.48 45 23.4428 45Z",
    fill: "url(#paint7_linear_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4428 45C28.4055 45 32.4285 41.0041 32.4285 36.075C32.4285 31.1459 28.4055 27.15 23.4428 27.15C18.48 27.15 14.457 31.1459 14.457 36.075C14.457 41.0041 18.48 45 23.4428 45Z",
    fill: "url(#paint8_linear_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43352 22.95H19.4808C21.3771 22.95 22.9143 24.4791 22.9143 26.3655V36.3346C22.9143 38.2209 21.3771 39.75 19.4808 39.75H9.43352C7.53715 39.75 6 38.2209 6 36.3346V26.3655C6 24.4791 7.53715 22.95 9.43352 22.95Z",
    fill: "url(#paint9_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43352 22.95H19.4808C21.3771 22.95 22.9143 24.4791 22.9143 26.3655V36.3346C22.9143 38.2209 21.3771 39.75 19.4808 39.75H9.43352C7.53715 39.75 6 38.2209 6 36.3346V26.3655C6 24.4791 7.53715 22.95 9.43352 22.95Z",
    fill: "url(#paint10_radial_457_426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8135 34.2605L12.6475 33.3096C12.8547 33.7246 13.1238 34.0304 13.4567 34.227C13.7934 34.4235 14.1626 34.522 14.562 34.522C15.007 34.522 15.3464 34.4327 15.5796 34.2539C15.8135 34.0708 15.93 33.7962 15.93 33.4306C15.93 33.1452 15.8178 32.904 15.5932 32.7074C15.3685 32.5066 14.9707 32.3547 14.3997 32.252C13.3122 32.0555 12.5208 31.7119 12.027 31.2207C11.5372 30.7292 11.2924 30.1176 11.2924 29.3862C11.2924 28.4756 11.6157 27.7482 12.2635 27.2028C12.9101 26.6585 13.7647 26.3864 14.8256 26.3864C15.5397 26.3864 16.1691 26.5318 16.7127 26.8215C17.2567 27.1113 17.6881 27.527 18.0074 28.0674L16.2146 28.9845C16.017 28.6814 15.8033 28.4622 15.5744 28.3286C15.3448 28.1898 15.0578 28.1209 14.7114 28.1209C14.2978 28.1209 13.9834 28.2102 13.7674 28.389C13.5563 28.5678 13.4507 28.7998 13.4507 29.0853C13.4507 29.3307 13.552 29.5473 13.7539 29.7346C13.9607 29.9177 14.3737 30.0674 14.9945 30.1832C16.0372 30.3797 16.815 30.7367 17.3266 31.2552C17.8435 31.7684 18.1018 32.4177 18.1018 33.2039C18.1018 34.1591 17.7937 34.9157 17.1781 35.4735C16.5623 36.0314 15.6835 36.3103 14.5426 36.3103C13.7159 36.3103 12.9694 36.1314 12.3048 35.7744C11.6444 35.4132 11.148 34.9082 10.8151 34.2605H10.8135Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_457_426",
    x1: 13.7843,
    y1: 5.05968,
    x2: 30.5698,
    y2: 27.2068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0097A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007791"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.44968 -17.9081 -32.4182 13.3039 26.1755 32.0725)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#003B5D",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#004A6C",
    stopOpacity: 0.138039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#006F94",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.18402 -15.1568 -27.4043 11.0297 24.3932 24.7346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#002A42",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#004261",
    stopOpacity: 0.213825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#006F94",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.79252 11.2827 11.3596 7.74003 29.2941 5.34687)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78EDFF",
    stopOpacity: 0.698039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCFCA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_457_426",
    x1: 26.7008,
    y1: 17.3161,
    x2: 40.6888,
    y2: 35.7724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00A2B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#00637C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.30215 -12.2684 -22.2558 -7.69849 26.7813 33.7508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003B5D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#004C6C",
    stopOpacity: 0.362199
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#007A86",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.49369 9.40217 9.466 6.44981 39.1981 17.3508)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78EDFF",
    stopOpacity: 0.698039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCFCA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_457_426",
    x1: 18.9555,
    y1: 27.1475,
    x2: 27.8556,
    y2: 45.0401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#75FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0096AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_457_426",
    x1: 30.695,
    y1: 46.1987,
    x2: 25.9312,
    y2: 39.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0E5A5D",
    stopOpacity: 0.321569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#126C6B",
    stopOpacity: 0.221945
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1C948A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.9394 16.8267 16.9424 -16.8238 8.56211 23.5584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00B6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00495C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_457_426",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.221 33.1391) rotate(90) scale(11.7777 13.4991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1ECBE6",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 42,
    fill: "white",
    transform: "translate(6 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/sharepoint.2883b6ca0fda77a636db1b7475310fdc.svg";
export { ForwardRef as ReactComponent };